import { useMemo } from 'react'
import Grid from '@material-ui/core/Grid';

export default function TwoPointThreeSubHeader({ sub_label_type }) {
	const firstValueWidth = useMemo(() => {
		if (sub_label_type === 3 || sub_label_type === 2) {
			return 'w-4/12'
		}

		return 'w-4/12'
	}, [sub_label_type])

	const secondValueWidh = useMemo(() => {
		if (sub_label_type === 3 || sub_label_type === 2) {
			return 'w-3/12'
		}

		return 'w-5/12'
	}, [sub_label_type])

	const validationWidth = useMemo(() => {
		if (sub_label_type === 3 || sub_label_type === 2) {
			return 'w-2/12'
		}

		return 'w-3/12'
	}, [sub_label_type])

	return (
		<Grid className="col-span-12 text-center border border-b-0 flex flex-row justify-around">
			{(sub_label_type === 3 || sub_label_type === 2) && (
				<Grid className="border-r w-3/12 p-1 font-bold" />
			)}
			<Grid
				className={`border-r ${firstValueWidth} p-1 font-bold bg-month_table_blue_bg`}>
				สถานที่ในส่วนภูมิภาค
			</Grid>
			<Grid className={`border-r ${secondValueWidh} p-1 font-bold`}>
				สถานที่ในเขตกรุงเทพฯ และ ปริมณฑล
			</Grid>
			<Grid className={`border-r ${validationWidth} p-1 font-bold`} />
		</Grid>
	)
}
